module.exports = __webpack_public_path__ + "img/covidCaseJul11to17-2022.44dd9781.jpg";